import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ScrollView, View,  } from '@dbk/ui-react-utils';
import { NavigationList, NavigationListItem, NavigationListItemHeader, NavigationListItemFooter, NavigationListItemContent } from '@dbk/ui-list';
import Badge from '@dbk/ui-badge';
import { TouchableOpacity, StyleSheet } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import { SELECTED_RANGE, REPORT_CATEGORY  } from '../constants';
import { LoadingCircle } from '../../../../../../src/components/common/loading';
import { PALETTE, EBANKINGWEBLUX, EBANKINGWEB } from '../../../constants';
import envConfig from '../../../../../../db-env-build';
import { RM_REGION, RM_REGION_CH, REPORTS, KEY_CODE } from '../../../../../../src/constants';
import { Tab, Tabs } from '@dbk/ui-tabs';
import Grid, { Cell } from '@dbk/ui-grid';
import { Checkbox } from '@dbk/ui-forms';
import {Visible, DownloadIcon, CardMenu} from '@dbk/ui-icons';
import OutsideClickNotifier from './outside-click-notifier';
import Text from '@dbk/ui-text';




class ReportStatement extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      selectedItem: 0,
      detailModel: true,
      loadingRow: null,
      showMoreTabs: false,
      isHoveredOnCardMenu: false,
    };
    
  }

  /**
   * function: onRowClick will be called from Navigation List item.
   * It will route the screen to detail view of category list.
   */
  // onRowClick = (index, docCategoryId, docCategoryName) => {    //to be deleted
  //   this.setState({ selectedItem: index });
  //   this.props.setSelectedCategoryId(docCategoryId, docCategoryName);
  // }

  componentWillMount() {

    // load intital tab
    const {reports: {selectedCategoryTabIndex}} = this.props
    this.handleSelectedIndex(selectedCategoryTabIndex ? selectedCategoryTabIndex : 0, this.rangeCategoryList())

  }

  /**
   * function: componentWillMount will be used to load the documents
  componentWillMount() {
    this.props.getDocuments();
  }
   */
  

  handleSelectedIndex = (index, categoryList, e) => {
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
      if(index <= REPORTS.VARIABLE_TAB_INDEX ){
        this.props.setSelectedCategoryId(categoryList[index].docCategoryId, categoryList[index].docCategoryName);
      }
      this.props.reports.setSelectedCategoryTabIndex(index);
    }
  }

  setRangeCategoryList = (categoryList) => {
    const { reports: { statement : { setLastWeek, setLastMonth, setlast90days, setCustomRangeList } , selectedReportDetailsDateRange } } = this.props;
    switch(selectedReportDetailsDateRange) {
      case SELECTED_RANGE.LAST_WEEK:
        setLastWeek(categoryList);
        break;
      case SELECTED_RANGE.LAST_MONTH:
        setLastMonth(categoryList);
        break;
      case SELECTED_RANGE.last90days:
        setlast90days(categoryList);
        break;
      case SELECTED_RANGE.CUSTOM:
        setCustomRangeList(categoryList);
        break;
      default:
        
    }
    return categoryList;
  }

  variableTabsHandler = (rowIndex, categoryList, e) => {
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
      const { reports: { swapCategories } } = this.props;
      swapCategories(rowIndex , categoryList);
      this.setState({
        ...this.state, showMoreTabs: false
      })
    }
  }

  renderCell = ({ rowIndex}) => {
    const categoryList = this.rangeCategoryList();
    const {i18n: { messages }}=this.props;
    return (
      <Cell tabIndex={-1}  onClick = { () => this.variableTabsHandler(rowIndex, categoryList) }>
        <View className='category-tabs__tab--cell_view' tabIndex={0} onKeyDown={ (e) => this.variableTabsHandler(rowIndex, categoryList, e) }>
        <View className='category-tabs__tab--cell_view--cell_text'><Text>{categoryList[rowIndex + REPORTS.NUMBAR_OF_FIXED_TABS].docCategoryName}</Text></View>
         <View >
         {categoryList[rowIndex + REPORTS.NUMBAR_OF_FIXED_TABS].docCategoryName != REPORT_CATEGORY.ALL_DOCUMENTS && 
          <div aria-label={messages['app.reports.count']+(categoryList[rowIndex + REPORTS.NUMBAR_OF_FIXED_TABS].countOfUnreadDocs)}>
           <Badge value={categoryList[rowIndex + REPORTS.NUMBAR_OF_FIXED_TABS].countOfUnreadDocs} className="badge-color"/>
          </div>}
         </View>
        </View>
      </Cell>
    )
  }

  columnWidth() {
    return '100%';
  }

  renderCategoryTab = (item, index) => {
    const categoryList = this.rangeCategoryList();
    const {i18n: { messages }}=this.props;
    return (
      <Tab 
      className="tabFocus" // className added for accessibility selection made visible by adding css
      onKeyDown={(event) => this.handleSelectedIndex(index, categoryList, event)}
        renderLabel={ () => 
          <View className='category-tabs__tab' style={{width: "99%" }}>
            <Text size="large" className="category-tabs__tab--text">{item.docCategoryName}</Text>
            <div aria-label={messages['app.reports.count']+(item.countOfUnreadDocs)}>
              <Badge className="badge-color" value={item.countOfUnreadDocs}/>
            </div>
          </View>
        }
      />
    )
  }

  rangeCategoryList = () => {
    const { i18n: { messages }, reports: { statement : { lastWeek, lastMonth, last90days, customRangeList } , selectedReportDetailsDateRange } } = this.props;
    let categoryList = [];
    switch(selectedReportDetailsDateRange) {
      case SELECTED_RANGE.LAST_WEEK:
        categoryList = lastWeek;
        break;
      case SELECTED_RANGE.LAST_MONTH:
        categoryList = lastMonth;
        break;
      case SELECTED_RANGE.LAST_90_DAYS:
        categoryList = last90days;
        break;
      case SELECTED_RANGE.CUSTOM:               // TODO:  Revisit this condition again
        categoryList = customRangeList;
        // categoryList = (customRangeList && customRangeList.length > 0) ? customRangeList : 
        // (envConfig.envConfig === EBANKINGWEBLUX || envConfig.rmRegion === RM_REGION) ? JSON.parse(messages["app.chdelivery.reports.defaultCategoryList"]).categoryIdAndDocsList : JSON.parse(messages["app.chdelivery.reports.defaultCategoryListForCH"]).categoryIdAndDocsList;
        break;
      default:
        categoryList = []
    }
    return categoryList;
  }

  handleClickOutside(event) {
    this.setState({...this.state,showMoreTabs: false });
  }

  setShowMoreTabs = (e) => {
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
      this.setState((state, props) => ({
        showMoreTabs: !state.showMoreTabs
      }));
    }
  }
  onhoverEnter = ()  =>{
    this.setState({...this.state, isHoveredOnCardMenu: true})
  }
  onhoverleave = () => {
    this.setState({...this.state, isHoveredOnCardMenu: false})
  }
  
  findUnreadDocCountForOthers = (categoryList) => {
    return( categoryList.slice(REPORTS.NUMBAR_OF_FIXED_TABS)
      .filter(doc => doc.docCategoryName != REPORT_CATEGORY.ALL_DOCUMENTS)
      .reduce((sum, doc) => sum + (doc.countOfUnreadDocs || 0), 0)
    );
  }

  renderCategoryTabs = () => {
    const { i18n: { messages }, reports: { selectedCategoryTabIndex } } = this.props;
    const categoryList = this.rangeCategoryList();
    return (
      <View>
        <div className='category-container'>
          <div className='tabs-container'>
            <Tabs
              tabIndex="0"
              className="category-tabs"
              stretch
              secondary
              handleSelectedIndex={(index) => this.handleSelectedIndex(index, categoryList)}
              selectedIndex={selectedCategoryTabIndex} >
              {
                categoryList.slice(0,REPORTS.NUMBAR_OF_FIXED_TABS).map((item, key)=> {
                  return this.renderCategoryTab(item, key);
                })
              }
            </Tabs>
          </div>
          <OutsideClickNotifier onKeyDown={(e) => this.setShowMoreTabs(e)}  handler={this.handleClickOutside.bind(this)}>
            <div onClick={() => this.setShowMoreTabs()} onKeyDown={(e) => this.setShowMoreTabs(e)} className='more-tab-container' tabIndex={0}>

              <div onMouseEnter={this.onhoverEnter} onMouseLeave={this.onhoverleave} className='cardmenu' aria-label={messages['app.reports.moreItems']} role="button">
                <CardMenu color={this.state.isHoveredOnCardMenu ? PALETTE.primaryActive : PALETTE.secondaryActive} height={24} width={24} />
              </div>
              <div aria-label={messages['app.reports.count']+(this.findUnreadDocCountForOthers(categoryList))}>
                <Badge value={this.findUnreadDocCountForOthers(categoryList)} className="badge-color"/>  
              </div>
            </div>

           { this.state.showMoreTabs && 
                <div className='variable-tabs' tabIndex={-1}>
                  <Grid
                    tabIndex="-1"
                    ref={this.setRef}
                    rowCount={categoryList.length - REPORTS.NUMBAR_OF_FIXED_TABS}
                    stickyTopRowCount={categoryList.length - REPORTS.NUMBAR_OF_FIXED_TABS}
                    rowHeight={() => 52}
                    columnCount={1}
                    columnWidth={this.columnWidth}
                    renderCell={this.renderCell}
                  />
                </div>
            }
          </OutsideClickNotifier>

        </div>
      </View>
    )
  }


// /**
//  * function: renderDataExtractView will render the eDocument View
//  */
// renderDataExtractView = () => {
//   const { i18n: { messages } } = this.props;
//   return <div>
//     <Large >{messages['validation.reports.transactions.noData']}</Large>
//   </div>
// }

render() {
  return (
    <View>
      {/* {this.renderEDocumentView()}   // to be deleted  */}
      {this.renderCategoryTabs()}
      {}
    </View>
  );
}
}

ReportStatement.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object,
  }),
  selectedItem: PropTypes.bool,
  detailModel: PropTypes.bool,
  loadingRow: null,
};

ReportStatement.defaultProps = {
  i18n: {},
  selectedItem: PropTypes.bool,
  detailModel: PropTypes.bool,
  loadingRow: null,
};

export default createContainer({
  $queries: {
    edelivery: {
      getUserPreferences: { $call: 'getUserPreferences' },
      showPrompt: true,
    },
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    getLastStatements: {
      $call: 'reports.getLastStatements',
    },
    setSelectedCategoryId: {
      $call: 'reports.setSelectedCategoryId'
    },
    getDocuments: {
      $call: 'reports.getDocuments',
    },
    reports: {
      showSpinner: true,
      lastMonthStatements: true,
      totalUnreadDocs: true,
      statement: {
        lastWeek: true,
        lastWeekTotalUnreadDocs: true,
        lastMonth: true,
        lastMonthTotalUnreadDocs: true,
        customRangeList: true,
        customRangeUnreadList: true,
        customRangeTotalUnreadDocs: true,
        defaultList: true,
        last90days: true,
        setLastWeek: { $set: 'lastWeek' },
        setLastMonth: { $set: 'lastMonth' },
        setlast90days: { $set: 'last90days' },
        setCustomRangeList: { $set: 'customRangeList' },
      },
      selectedCategoryId: true,
      selectedReportDetailsDateRange: true,
      selectedCategoryTabIndex: true,
      setSelectedCategoryTabIndex: {
        $set: 'selectedCategoryTabIndex'
      },
      swapCategories: { $call: 'swapCategories' }
    },
    getStatementPdf: {
      $call: 'monthly.getPdf',
    },
    dailyPdf: {
      pdf: true,
      setEmpty: { $set: 'pdf' },
    },
    resetAdvicesDates: { $call: 'advices.resetDates' },
    resetReportsDates: { $call: 'reports.resetDates' },
    portfolio: {
      netIncome: {
        value: true,
      },
    },
  },
}
)(ReportStatement);
